// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-category-card',
    // #endregion
    // #region Properties
    props: {
        category: {
            type: Object,
            required: false,
            default: {}
        }
    },
    // #endregion
});
// #endregion
